import Trash from "@endya-conformite/ui-kit/src/assets/icons/trash.svg?react";
import { Button } from "@lya-protect/lya-protect-form-library/dist/UI";
import styles from "./FileDisplay.module.scss";

export function FileDisplay({
  fileName,
  onDelete,
}: {
  fileName: string;
  onDelete: () => void;
}) {
  return (
    <div className={styles.fileDisplay}>
      <span>{fileName}</span>
      <Button variant="text" icon={<Trash />} onClick={onDelete} />
    </div>
  );
}
